var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"my-3 d-flex align-items-center small",attrs:{"href":_vm.link},on:{"click":function($event){$event.preventDefault();return _vm.addToCalendar.apply(null, arguments)}}},[_c('i',{staticClass:"fa fa-calendar-plus-o me-2",staticStyle:{"font-size":"30px"}}),_vm._v("\n    "+_vm._s(_vm.__('Add to calendar'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }